import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createWorkflowStep,
  deleteWorkflowStep,
  getWorkflowStep,
  getWorkflowSteps,
  getWorkflowStepsMasterData,
  updateWorkflowStep
} from '../../../api/workflow-steps';
import { ProjectPositionWorkflowStep } from '../ProjectPositionWorkflowStep/projectPositionWorkflowStepSlice';

export const getWorkflowStepsAsync = createAsyncThunk(
  'workflowSteps/getWorkflowSteps',
  getWorkflowSteps
);

export const getWorkflowStepsMasterDataAsync = createAsyncThunk(
  'workflowSteps/getWorkflowStepsMasterData',
  getWorkflowStepsMasterData
);

export const getWorkflowStepAsync = createAsyncThunk(
  'workflowSteps/getWorkflowStep',
  getWorkflowStep
);

export const createWorkflowStepAsync = createAsyncThunk(
  'workflowSteps/createWorkflowStep',
  createWorkflowStep
);

export const updateWorkflowStepAsync = createAsyncThunk(
  'workflowSteps/updateWorkflowStep',
  updateWorkflowStep
);

export const deleteWorkflowStepAsync = createAsyncThunk(
  'workflowSteps/deleteWorkflowStep',
  deleteWorkflowStep
);

export interface WorkflowStep {
  id: number;
  name: string;
  order: number;
  isInternal: boolean;
  canStopWorkflow: boolean;
  isFinalApprover: boolean;
  isChecklist: boolean;
  projectPositionWorkflowSteps: ProjectPositionWorkflowStep[];
}

interface WorkflowStepState {
  data: WorkflowStep[];
  masterData: WorkflowStep[];
  count: number;
  selectedWorkflowStep: WorkflowStep | null;
}

const initialState: WorkflowStepState = {
  data: [],
  masterData: [],
  count: 0,
  selectedWorkflowStep: null
};

export default createSlice({
  name: 'workflowSteps',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWorkflowStepsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
    builder.addCase(
      getWorkflowStepsMasterDataAsync.fulfilled,
      (state, action) => {
        state.masterData = action.payload.data;
        state.count = action.payload.count;
      }
    );
    builder.addCase(getWorkflowStepAsync.fulfilled, (state, action) => {
      state.selectedWorkflowStep = action.payload;
    });
  }
});
